import { render, staticRenderFns } from "./PageHandle.vue?vue&type=template&id=159cd9bc&scoped=true"
import script from "./PageHandle.vue?vue&type=script&lang=js"
export * from "./PageHandle.vue?vue&type=script&lang=js"
import style0 from "./PageHandle.vue?vue&type=style&index=0&id=159cd9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159cd9bc",
  null
  
)

export default component.exports